import _ from 'lodash';
import React from 'react';
import { SIDE } from './Points/constants';

const tolerance = 40;

function isCollide(a, b) {
	const c1 = _.inRange(a.x, b.x - tolerance, b.x + b.width + tolerance);
	const c2 = _.inRange(a.y, b.y - tolerance, b.y + b.height + tolerance);

	return c1 && c2;
}

const distance = (position, destination) => {
	const diffX = position.x - destination.x;
	const diffY = position.y - destination.y;
	return Math.sqrt(diffX * diffX + diffY * diffY);
};

const getNearestPoint = (points, point) =>
	points.reduce((prev, curr) => {
		const currValue = distance(point, curr);
		const prevValue = distance(point, prev);
		return Math.abs(currValue) < Math.abs(prevValue) ? curr : prev;
	});

type SideParam = typeof SIDE[keyof typeof SIDE] | '';

type Props = {
	selectionCoords: {
		top: number;
		left: number;
		width: number;
		height: number;
		position: 'absolute' | 'fixed';
	};
	onNearestPoint: (side: SideParam) => void;
};

class NearestPoint extends React.Component<Props> {
	componentDidMount() {
		document.addEventListener('mousemove', this.onMouseMove);
	}

	componentWillUnmount() {
		document.removeEventListener('mousemove', this.onMouseMove);
	}

	onMouseMove = event => {
		const { selectionCoords } = this.props;

		const mouse = {
			x: event.pageX - (selectionCoords.position === 'absolute' ? 0 : document.documentElement.scrollLeft),
			y: event.pageY - (selectionCoords.position === 'absolute' ? 0 : document.documentElement.scrollTop),
		};

		const pointsRect = {
			x: selectionCoords.left,
			y: selectionCoords.top,
			width: selectionCoords.width,
			height: selectionCoords.height,
		};

		const x = {
			left: pointsRect.x,
			center: pointsRect.x + pointsRect.width / 2,
			right: pointsRect.x + pointsRect.width,
		};

		const y = {
			top: pointsRect.y,
			center: pointsRect.y + pointsRect.height / 2,
			bottom: pointsRect.y + pointsRect.height,
		};

		const points: { side: typeof SIDE[keyof typeof SIDE]; x: number; y: number }[] = [
			{ side: SIDE.top, x: x.center, y: y.top },
			{ side: SIDE.bottom, x: x.center, y: y.bottom },
			{ side: SIDE.right, x: x.right, y: y.center },
			{ side: SIDE.rightTop, x: x.right, y: y.top },
			{ side: SIDE.rightBottom, x: x.right, y: y.bottom },
			{ side: SIDE.left, x: x.left, y: y.center },
			{ side: SIDE.leftTop, x: x.left, y: y.top },
			{ side: SIDE.leftBottom, x: x.left, y: y.bottom },
		];

		let nearestPoint: { side: SideParam } = { side: '' };
		if (isCollide(mouse, pointsRect)) {
			nearestPoint = getNearestPoint(points, mouse);
		}
		this.props.onNearestPoint(nearestPoint.side);
	};

	render() {
		return null;
	}
}

export default NearestPoint;
